import { Col, Collapse, Row } from "antd";
import React from "react";
import TagComponent from "../../../../biblio/TagComponent";
import dayjs from "dayjs";
interface Props {
  requests: any;
}
const DroppedOutRequestsList = ({ requests }: Props) => {
  return (
    <div className="takaful--collapse-profile-container">
      <div
        className={`takaful--collapse-profile takaful--collapse-label-container takaful--collapse-beneficiary-services  `}
      >
        <Collapse.Panel
          showArrow={false}
          key="0"
          className=" takaful--collapse-label-panel"
          header={
            <div className="takaful--header-service-profile-container">
              <Row
                className="takaful--content-profile-box1"
                style={{ marginBottom: "0" }}
              >
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    رقم التسجيل
                  </p>
                </Col>
                <Col
                  xxl={7}
                  xl={7}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    تاريخ التسجيل
                  </p>
                </Col>
                <Col
                  xxl={7}
                  xl={7}
                  lg={7}
                  md={7}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    المستفيد
                  </p>
                </Col>
                <Col
                  xxl={4}
                  xl={4}
                  lg={4}
                  md={4}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">المرحلة</p>
                </Col>
              </Row>
            </div>
          }
        ></Collapse.Panel>
      </div>
      <Collapse
        className={`takaful--collapse-profile takaful--collapse-beneficiary-services takaful--collapse-sponsor-requests`}
        accordion
        defaultActiveKey={["0"]}
      >
        {requests?.map((element: any, index: number) => (
          <Collapse.Panel
            className="takaful--header-profile-Panel takaful--collapse-label-panel"
            key={index}
            showArrow={false}
            header={
              <div className="takaful--header-profile-container">
                <Row
                  align={"middle"}
                  className="takaful--content-profile-box1"
                  style={{ marginBottom: "0" }}
                >
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      رقم التسجيل
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.name}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      تاريخ التسجيل
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.date
                        ? dayjs(element?.date, "YYYY-MM-DD").format(
                            "YYYY/MM/DD"
                          )
                        : ""}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      المستفيد
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element && element?.partner_id[1]}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                    المرحلة
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <TagComponent
                      className="takaful--tag-component"
                      width="70%"
                      state={element?.state}
                      orangeValue="in_progress"
                      greenValue="done"
                      redValue="cancel"
                      text={
                        element.stage_id &&
                        element?.stage_id.length > 0 &&
                        element?.stage_id[1]
                      }
                    />
                  </Col>
                </Row>
              </div>
            }
          >
            <Row
              className={`takaful--content-profile-box1`}
              justify={"space-between"}
              gutter={16}
            >
              <Col
                xxl={7}
                xl={7}
                lg={7}
                md={7}
                sm={16}
                xs={10}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">
                  اخر سنة دراسة تحصل فيها على شهادة
                </p>
              </Col>
              <Col
                xxl={4}
                xl={4}
                lg={4}
                md={4}
                sm={8}
                xs={14}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.last_degree_year}
                </span>
              </Col>
              <Col
                xxl={4}
                xl={4}
                lg={4}
                md={4}
                sm={8}
                xs={10}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">
                  سبب الانقطاع
                </p>
              </Col>
              <Col
                xxl={9}
                xl={9}
                lg={9}
                md={9}
                sm={16}
                xs={14}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.reason}
                </span>
              </Col>
            </Row>
            <Row
              className={`takaful--content-profile-box1`}
              justify={"space-between"}
              gutter={16}
            >
              <Col
                xxl={7}
                xl={7}
                lg={7}
                md={7}
                sm={16}
                xs={10}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">
                  المعدل التراكمي
                </p>
              </Col>
              <Col
                xxl={17}
                xl={17}
                lg={17}
                md={17}
                sm={8}
                xs={14}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.accumulated_rate}
                </span>
              </Col>
            </Row>
          </Collapse.Panel>
        ))}
      </Collapse>
    </div>
  );
};

export default DroppedOutRequestsList;
